import axios from 'axios'
import { EntityDto } from '../../../../../services/dto/entityDto'
import { PagedResultDto } from '../../../../../services/dto/pagedResultDto'
import CreateJob from './dto/CreateJob'
import GetJob from './dto/GetJob'
import { PagedJobResultRequestDto } from './dto/PagedJobResultRequestDto'
import UpdateJob from './dto/UpdateJob'
import GetAllJobs from './dto/GetAllJobs'
import CreateJobApplication from './dto/CreateJobApplication'
import { PagedGraduatedJobApplicationResultRequestDto } from '../../my-applications/core/dto/PagedGraduatedJobApplicationResultRequestDto'
import GetGraduatedJobApplication from '../../my-applications/core/dto/GetGraduatedJobApplication'
import GetJobWithSeenDto from './dto/GetJobWithSeenDto'
import CreateJobApplicationState from './dto/CreateJobApplicationState'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Job/Create`
export const URL_DELETE = `${API_URL}/Job/Delete`
export const URL_GET = `${API_URL}/Job/Get`
export const URL_GET_ALL = `${API_URL}/Job/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Job/Update`
export const URL_CREATE_GRADUATED_JOB_APPLICATION = `${API_URL}/JobApplication/Create`
export const URL_CREATE_GRADUATED_JOB_STATE_APPLICATION = `${API_URL}/JobApplicationStateChange/Create`
export const URL_DELETE_GRADUATED_JOB_APPLICATION = `${API_URL}/JobApplication/Delete`
export const URL_GET_GRADUATED_JOB_APPLICATION = `${API_URL}/JobApplication/Get`
export const URL_GET_GRADUATED_JOBS_APPLICATION = `${API_URL}/JobApplication/GetPagedAll`
export const URL_GET_GRADUATED_JOB_APPLICATION_FOR_COMPANIES = `${API_URL}/JobApplication/GetPagedAllForCompanies`
export const URL_GET_GRADUATED_JOB_APPLICATION_FOR_ADMIN = `${API_URL}/JobApplication/GetPagedAllForAdmin`
export const URL_GET_KVKK_GRADUATED_JOB_APPLICATION = `${API_URL}/Kvkk/Get`


export function onGetKVKKGraduatedJobApplication(entityDto : EntityDto): Promise<boolean> {
  return axios.get(URL_GET_KVKK_GRADUATED_JOB_APPLICATION, { params: entityDto })
}
export function onCreateGraduatedJobApplication(createJobApplication: CreateJobApplication): Promise<boolean> {
  return axios.post(URL_CREATE_GRADUATED_JOB_APPLICATION, createJobApplication)
}
export function oncreateJobApplicationState(createJobApplicationState: CreateJobApplicationState): Promise<boolean> {
  return axios.post(URL_CREATE_GRADUATED_JOB_STATE_APPLICATION, createJobApplicationState)
}
export function onDeleteGraduatedJobApplication(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE_GRADUATED_JOB_APPLICATION, { params: entityDto })
}
export function onGetGraduatedJobApplication(entityDto: GetJobWithSeenDto): Promise<GetGraduatedJobApplication> {
  return axios.get(URL_GET_GRADUATED_JOB_APPLICATION, { params: entityDto })
}
export function onGetGraduatedJobsApplication( pagedFilterAndSortedRequest: PagedGraduatedJobApplicationResultRequestDto
  ): Promise<PagedResultDto<GetGraduatedJobApplication>> {
    return axios.get(URL_GET_GRADUATED_JOBS_APPLICATION, { params: pagedFilterAndSortedRequest })
}

export function onCreateJob(createJob: CreateJob): Promise<boolean> {
  return axios.post(URL_CREATE, createJob)
}

export function onDeleteJob(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, { params: entityDto })
}

export function onGetJob(entityDto: EntityDto): Promise<GetJob> {
  return axios.get(URL_GET, { params: entityDto })
}

export function onGetPagedAllJobs(
  pagedFilterAndSortedRequest: PagedJobResultRequestDto
): Promise<PagedResultDto<GetAllJobs>> {
  return axios.get(URL_GET_ALL, { params: pagedFilterAndSortedRequest })
}
export function onGetPagedAllJobApplicationsForCompanies(
  pagedFilterAndSortedRequest: PagedGraduatedJobApplicationResultRequestDto
): Promise<PagedResultDto<GetGraduatedJobApplication>> {
  return axios.get(URL_GET_GRADUATED_JOB_APPLICATION_FOR_COMPANIES, { params: pagedFilterAndSortedRequest })
}

export function onGetPagedAllJobApplicationsForAdmin(
  pagedFilterAndSortedRequest: PagedGraduatedJobApplicationResultRequestDto
): Promise<PagedResultDto<GetGraduatedJobApplication>> {
  return axios.get(URL_GET_GRADUATED_JOB_APPLICATION_FOR_ADMIN, { params: pagedFilterAndSortedRequest })
}

export function onUpdateJob(updateJobInput: UpdateJob): Promise<boolean> {
  return axios.put(URL_UPDATE, updateJobInput)
}
